import type { PerUnitProduct } from '@vy/services';
import type { UsageProductInput } from '@vy/types';
import React from 'react';
import { useDialog } from '../../../../../../../../hooks/use-dialog';
import { ModifyButton } from '../../../../ModifyButton';
import { UsageFeesModifyPanel } from '../../../../UsageFeesModifyPanel';

type PerUnitUsageChargeEditBottomSectionProps = {
  productIndex: number;
  product: PerUnitProduct;
};

export const PerUnitUsageChargeEditBottomSection: React.FC<PerUnitUsageChargeEditBottomSectionProps> = ({
  product,
}) => {
  const { isDialogOpen: isDrawerOpen, handleOpen, handleClose } = useDialog();

  return (
    <div className="border-t-line flex items-center justify-between">
      <ModifyButton isDialogOpen={isDrawerOpen} handleOpen={handleOpen} />

      <UsageFeesModifyPanel
        open={isDrawerOpen}
        onClose={handleClose}
        usageProduct={product as UsageProductInput}
      />
    </div>
  );
};
